<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <div class="item">
            <el-button size="small" type="primary" @click="loadTree">查询</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="toggleAllExpand(true)">一键展开</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="toggleAllExpand(false)">一键收起</el-button>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="showAddRoot">新增下级</el-button>
          </div>
        </div>
      </div>

      <el-row :gutter="16" class="split-layout">
        <el-col :span="9">
          <el-card shadow="never" class="left-tree-card">
            <div slot="header" class="tree-header">系统菜单树</div>
            <el-input
              v-model="treeKeyword"
              size="small"
              clearable
              placeholder="搜索名称/编码/路径"
              class="tree-search"
            />
            <el-tree
              ref="menuTree"
              :data="tabList"
              node-key="id"
              highlight-current
              :default-expand-all="false"
              :props="{ children: 'childList', label: 'name' }"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <span slot-scope="{ data }" class="tree-node">
                <span class="tree-node-label">
                  <span>{{ data.name }}</span>
                  <el-tag size="mini" type="info" class="type-tag">{{ data.code }}</el-tag>
                </span>
                <span class="tree-node-actions">
                  <el-button type="text" size="mini" @click.stop="showAddChild(data)">新增下级</el-button>
                  <el-button type="text" size="mini" @click.stop="showEdit(data)">编辑</el-button>
                </span>
              </span>
            </el-tree>
          </el-card>
        </el-col>

        <el-col :span="15">
          <el-card shadow="never" class="right-form-card">
            <div slot="header" class="detail-header">
              <span>{{ title }}</span>
              <span class="detail-header-right">
                <el-tag v-if="!isEditMode" size="mini" type="info">查看模式</el-tag>
                <el-tag v-else size="mini" type="warning">编辑模式</el-tag>
                <span v-if="selectedNode && selectedNode.id" class="detail-id">ID: {{ selectedNode.id }}</span>
              </span>
            </div>

            <el-form :model="formData" label-width="110px" size="medium">
              <el-form-item label="名称" required>
                <el-input v-model="formData.name" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="编码" required>
                <el-input v-model="formData.code" :disabled="!isEditMode" placeholder="例如: system_permission" />
              </el-form-item>
              <el-form-item label="路径" required>
                <el-input v-model="formData.url" :disabled="!isEditMode" placeholder="例如: /home/system/menu" />
              </el-form-item>
              <el-form-item label="父级ID">
                <el-input v-model="formData.parentId" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="图标">
                <el-input v-model="formData.icoName" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="排序(1-100)">
                <el-input-number
                  v-model="formData.sortCode"
                  :min="1"
                  :max="100"
                  style="width: 100%"
                  :disabled="!isEditMode"
                />
              </el-form-item>
              <el-form-item label="描述">
                <el-input v-model="formData.description" type="textarea" :rows="3" :disabled="!isEditMode" />
              </el-form-item>
            </el-form>

            <div class="detail-actions">
              <el-button v-if="selectedNode && selectedNode.id && !isEditMode" type="primary" @click="enableEdit"
                >进入编辑</el-button
              >
              <el-button v-if="selectedNode && selectedNode.id && isEditMode" @click="cancelEdit">取消编辑</el-button>
              <el-button v-if="isEditMode" type="primary" @click="handleSave">{{
                formData.id ? "保存修改" : "创建节点"
              }}</el-button>
              <el-button v-if="selectedNode && selectedNode.id" type="danger" @click="remove(selectedNode)"
                >删除当前节点</el-button
              >
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import api from "./api";

const defaultForm = () => ({
  id: undefined,
  name: "",
  code: "",
  url: "",
  parentId: "0",
  icoName: "",
  sortCode: 1,
  description: "",
});

export default {
  data() {
    return {
      tabList: [],
      title: "新增节点",
      selectedNode: null,
      treeKeyword: "",
      isEditMode: true,
      formData: defaultForm(),
    };
  },
  watch: {
    treeKeyword(val) {
      this.$refs.menuTree && this.$refs.menuTree.filter(val);
    },
  },
  mounted() {
    this.loadTree();
  },
  methods: {
    loadTree() {
      api.tree({}).then((res) => {
        if (res.code == 0) {
          this.tabList = res.data || [];
          this.selectedNode = null;
          this.resetForm();
        }
      });
    },
    handleNodeClick(row) {
      this.selectedNode = row;
      this.showEdit(row);
      this.isEditMode = false;
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return (
        (data.name || "").includes(value) ||
        (data.code || "").includes(value) ||
        (data.url || "").includes(value)
      );
    },
    enableEdit() {
      this.isEditMode = true;
    },
    toggleAllExpand(expanded) {
      if (!this.$refs.menuTree || !this.$refs.menuTree.store) {
        return;
      }
      const nodesMap = this.$refs.menuTree.store.nodesMap || {};
      Object.keys(nodesMap).forEach((key) => {
        nodesMap[key].expanded = expanded;
      });
    },
    cancelEdit() {
      if (this.selectedNode && this.selectedNode.id) {
        this.showEdit(this.selectedNode);
        this.isEditMode = false;
      }
    },
    showAddRoot() {
      if (!this.selectedNode || !this.selectedNode.id) {
        return this.$message.warning("请先在左侧选择父级节点");
      }
      this.showAddChild(this.selectedNode);
    },
    showAddChild(row) {
      this.title = "新增下级";
      this.selectedNode = row;
      this.formData = defaultForm();
      this.formData.parentId = row.id;
      this.isEditMode = true;
    },
    showEdit(row) {
      this.title = "编辑节点";
      this.formData = {
        id: row.id,
        name: row.name || "",
        code: row.code || "",
        url: row.url || "",
        parentId: row.parentId || "0",
        icoName: row.icoName || "",
        sortCode: row.sortCode || 1,
        description: row.description || "",
      };
    },
    resetForm() {
      this.title = "新增节点";
      this.formData = defaultForm();
      this.isEditMode = true;
    },
    handleSave() {
      if (!this.formData.name) {
        return this.$message.error("请输入名称");
      }
      if (!this.formData.code) {
        return this.$message.error("请输入编码");
      }
      if (!this.formData.url) {
        return this.$message.error("请输入路径");
      }
      const payload = {
        ...this.formData,
      };
      const req = this.formData.id ? api.update : api.add;
      req(payload).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          const keepId = this.formData.id;
          this.loadTree();
          if (keepId) {
            this.$nextTick(() => {
              this.$refs.menuTree && this.$refs.menuTree.setCurrentKey(keepId);
            });
          }
          this.isEditMode = false;
        }
      });
    },
    remove(row) {
      this.$confirm("删除后将同时删除所有子节点，确认继续吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.remove({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.selectedNode = null;
            this.resetForm();
            this.loadTree();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.split-layout {
  margin-top: 8px;
}

.left-tree-card,
.right-form-card {
  height: calc(100vh - 240px);
  overflow: auto;
}

.tree-header,
.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.tree-search {
  margin-bottom: 10px;
}

.detail-header-right {
  display: inline-flex;
  align-items: center;
}

.detail-id {
  color: #909399;
  font-weight: 400;
  font-size: 12px;
  margin-left: 8px;
}

.tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tree-node-label {
  display: inline-flex;
  align-items: center;
}

.type-tag {
  margin-left: 8px;
}

.tree-node-actions {
  margin-left: 8px;
}

.detail-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}
</style>
